import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FC } from "react";

import { black, labelColor, text } from "@/modules/irohana-components/theme/colors-new";

export const LABEL_TAG_COLORS = {
  success: { bg: labelColor.success, text: text.primary },
  incomplete: { bg: labelColor.incomplete, text: text.primary },
  progress: { bg: labelColor.progress, text: text.primary },
  error: { bg: labelColor.error, text: text.primary },
  disable: { bg: labelColor.complete, text: text.tertiary },
  uncreated: { bg: labelColor.disable, text: text.primary },
  normal: { bg: "transparent", text: text.primary },
  purple: { bg: labelColor.purple, text: text.primary },
  deepPurple: { bg: labelColor.deepPurple, text: text.primary },
  lightBlue: { bg: labelColor.lightBlue, text: text.primary },
  teal: { bg: labelColor.teal, text: text.primary },
  lightGreen: { bg: labelColor.lightGreen, text: text.primary },
  yellow: { bg: labelColor.yellow, text: text.primary },
} as const;

export type TLabelTagColor = keyof typeof LABEL_TAG_COLORS;

type TLabelTagProps = {
  label: string;
  color?: TLabelTagColor;
  backgroundColor?: string;
  textColor?: string;
};

export const LabelTag: FC<TLabelTagProps> = ({ label, color = "success", backgroundColor, textColor }) => {
  const colorConfig = LABEL_TAG_COLORS[color];

  return (
    <StyledLabelTag bgColor={backgroundColor || colorConfig.bg} txtColor={textColor || colorConfig.text} isOutline={color === "normal"}>
      <Typography variant="cap12">{label}</Typography>
    </StyledLabelTag>
  );
};

const StyledLabelTag = styled("span", {
  shouldForwardProp: (prop) => !["bgColor", "txtColor", "isOutline"].includes(prop as string),
})<{ bgColor: string; txtColor: string; isOutline: boolean }>(({ bgColor, txtColor, isOutline }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "4px 8px",
  minWidth: "60px",
  borderRadius: "100px",
  height: "26px",
  backgroundColor: bgColor,
  border: isOutline ? `1px solid ${black[95]}` : "none",
  whiteSpace: "nowrap",
  "& .MuiTypography-root": {
    color: txtColor,
    fontWeight: 400,
    lineHeight: "150%",
  },
}));
